/**
 * Calculates and formats the time elapsed since a given timestamp
 * @param timestamp Unix timestamp in seconds
 * @returns Formatted string representing elapsed time
 */
export const timeSinceLastSync = (timestamp: number): string => {
  if (!timestamp) return "--";

  // Convert timestamp to milliseconds and calculate difference
  const now = Math.floor(Date.now() / 1000);
  const diffInSeconds = now - timestamp;

  // Less than a minute
  if (diffInSeconds < 60) {
    return "just now";
  }

  // Minutes (less than an hour)
  if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `${minutes} ${minutes === 1 ? "minute" : "minutes"} ago`;
  }

  // Hours (less than a day)
  if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `${hours} ${hours === 1 ? "hour" : "hours"} ago`;
  }

  // Days (less than a month - approximated as 30 days)
  if (diffInSeconds < 2592000) {
    const days = Math.floor(diffInSeconds / 86400);
    return `${days} ${days === 1 ? "day" : "days"} ago`;
  }

  // Months (less than a year)
  if (diffInSeconds < 31536000) {
    const months = Math.floor(diffInSeconds / 2592000);
    return `${months} ${months === 1 ? "month" : "months"} ago`;
  }

  // Years
  const years = Math.floor(diffInSeconds / 31536000);
  return `${years} ${years === 1 ? "year" : "years"} ago`;
};
